import React from "react";
import { ErrorMessage, Field } from "formik";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { validateAddress } from "../../../utilities/ValidationHelper";

const AddressStep = () => {
  const ADDRESS_STEP_STRINGS = GeneralStrings.ENROLL.FORM_LABELS.ADDRESS_STEP;
  return (
    <div className="step">
      <h4
        className="step-header"
        dangerouslySetInnerHTML={{ __html: ADDRESS_STEP_STRINGS.HEADER_HTML }}
      />
      <div className="question-container">
        <div className="form-group">
          <Field
            name="address"
            className="form-control"
            placeholder={GeneralStrings.FORM.ADDRESS}
            validate={validateAddress}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="address"
          />
        </div>
      </div>
    </div>
  );
};

export default AddressStep;
